export enum CacheUsersInitiator {
  InitialCache = 'InitialCache',
  UserUpdated = 'UserUpdated',
  UserCreated = 'UserCreated',
  UserDeleted = 'UserDeleted',
  UserInvited = 'UserInvited',
  PageLeave = 'PageLeave',
  AutoClearFiltersUpdated = 'AutoClearFiltersUpdated',
}

export enum CacheEvidencesInitiator {
  InitialCache = 'InitialCache',
  EvidenceUploaded = 'EvidenceUploaded',
  EvidenceUpdated = 'EvidenceUpdated',
  EvidenceProcessed = 'EvidenceProcessed',
  PageLeave = 'PageLeave',
  AutoClearFiltersUpdated = 'AutoClearFiltersUpdated',
}
